import "../styles/main.css"

import { initMap } from "./mapbox"
import EmblaCarousel from "embla-carousel"
import { addDotButtonAndClickHandlers } from "./EmblaCarouselDotButton"
import { addPrevNextButtonClickHandlers } from "./EmblaCarouselArrowButtons"
import { initStackCards } from "./stackCards.js"
import { initNavigationMenu } from "./menu"


function initEmbla() {
  document.querySelectorAll(".embla").forEach(emblaNode => {
    const viewportNode = emblaNode.querySelector(".embla__viewport")
    const prevBtn = emblaNode.querySelector(".embla__button--prev")
    const nextBtn = emblaNode.querySelector(".embla__button--next")
    const dotsNode = emblaNode.querySelector(".embla__dots")
    if (!viewportNode) return

    const emblaApi = EmblaCarousel(viewportNode, {
      loop: true,
      align: "start"
    })

    if (prevBtn && nextBtn) {
      addPrevNextButtonClickHandlers(emblaApi, prevBtn, nextBtn)
    }

    if (dotsNode) {
      addDotButtonAndClickHandlers(emblaApi, dotsNode)
    }
  })
}

async function initLaBastide() {
  if (!window.location.pathname.includes("/la-bastide")) return

  const { SpreadGrid } = await import("./SpreadGrid")

  document.querySelectorAll(".grid__galery").forEach(grid => {
    new SpreadGrid(grid)
  })
}

document.querySelectorAll(".open-modal").forEach(button => {
  button.addEventListener("click", () => {
    const modal = document.getElementById(button.dataset.modal)

    if (modal) modal.showModal()
  })
})

document.addEventListener("DOMContentLoaded", async () => {
  initNavigationMenu()
  initEmbla()
  initStackCards()
  initLaBastide()
  initMap()
})


